import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import Loading from "../../components/Loading ";
import { ADD } from "../../Redux/actions/CartAction";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const Request = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [priceNotification, setPriceNotification] = useState(null);
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.user);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        let baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(baseUrl + "/api/requests");
        setRequests(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching requests:", error);
        setError("Failed to fetch requests. Please try again later.");
        setLoading(false);
      }
    };

    fetchRequests();
  }, []);

  const handleAddToCart = (request) => {
    if (isLoggedIn) {
      const product =
        request.product && request.product.price !== "0.00"
          ? request.product
          : {
              name: request.product
                ? request.product.name
                : "Product Unavailable",
              price: request.price,
            };

      const updatedProduct = {
        id: request.id,
        name: request.product?.name || "Product Unavailable",
        price: product.price === "0.00" ? request.price : product.price,
        requestPrice: request.price,
      };

      dispatch(ADD(updatedProduct));
      Swal.fire({
        title: "Success!",
        text: "Added to Cart successfully",
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });
    } else {
      Swal.fire({
        title: "Please Login",
        text: "Please login to add the product to your cart.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/login";
        }
      });
    }
  };

  useEffect(() => {
    const latestRequest = requests.find(
      (request) => request.price && request.price !== "0.00"
    );

    if (latestRequest) {
      const productName = latestRequest.product?.name || "Unknown Product";
      const productPrice = latestRequest.price;
      setPriceNotification(
        `Admin Quota: Price for ${productName} is now available at ${productPrice}`
      );
    }
  }, [requests]);

  useEffect(() => {
    if (priceNotification) {
      Swal.fire({
        title: "Admin Quota Alert",
        text: priceNotification,
        icon: "info",
        timer: 5000,
        showConfirmButton: false,
      });
      setPriceNotification(null);
    }
  }, [priceNotification]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="dash-card about-bg">
      <Card className="dash-sub-card">
        <Card.Header as="h4" className="dash-card-header">
          Request Quotes
        </Card.Header>
        <Card.Body>
          <Table striped bordered hover variant="light">
            <thead>
              <tr>
                <th>Left Width</th>
                <th>Overall Width</th>
                <th>Right Width</th>
                <th>Interested Product</th>
                <th>Price</th>
                <th>Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request) => (
                <tr key={request.id}>
                  <td>{request.left_width}</td>
                  <td>{request.overall_width}</td>
                  <td>{request.right_width}</td>
                  <td>{request.product ? request.product.name : "N/A"}</td>
                  <td>
                    {/* Check if the price is available */}
                    {request.price && request.price !== "0.00" ? (
                      <span>{request.price}</span>
                    ) : (
                      <span>Please wait...</span>
                    )}
                  </td>
                  <td>{request.message}</td>
                  <td>
                    {/* Only show "Add to Cart" if price is available */}
                    {request.price && request.price !== "0.00" ? (
                      <button
                        className="custom_btn_card"
                        onClick={() =>
                          handleAddToCart({
                            id: request.id,
                            name: request.product
                              ? request.product.name
                              : "N/A",
                            price: request.price,
                            requestPrice: request.price,
                          })
                        }
                      >
                        <Link to="#">Add To Cart</Link>
                      </button>
                    ) : null}{" "}
                    {/* Do not show the button if the price is not available */}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Request;
